<template>
    <slot name="product-add-cart" v-bind="this"></slot>
</template>

<script>
    export default {
        props: {
            productId: null,
            productQuantity: null,
            variantId: null
        },
        methods: {
            addToCart() {
                this.$emit('wait', true);
                this.$emit('add-to-cart', {
                    productId: this.productId,
                    productQuantity: this.productQuantity,
                    variantId: this.variantId
                }),
                this.$emit('cart-updated')
            }
        },
    }
</script>
